import React, {Fragment, useEffect, useRef, useState} from "react";
import {Grid, AutoSizer} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import SelectionGridFiltersTitle from "./selectionGridFiltersTitle";
import SelectionGridItem from "./selectionGridItem";
import {shiftFilterTitleInterface} from "../../../interfaces/shiftFilterTitleInterface";
import {getFilterGroupValues} from "../../../misc/utils";

const SelectionMainVirtualizedFiltersGridMobile = (props) => {

  const {currentFeatures, handleFeatureClick, handleUserLoginClick, listItemHeight, onScroll, selectionWindowView,
    checkIfFeatureSelected, scrollElement, currentParent, filterGroups} = props;

  const [currentFilter, setCurrentFilter] = useState(null);
  const [defaultTitle, setDefaultTitle] = useState(null); // never changes, is needed for arrows only
  const [gridFeatures, setGridFeatures] = useState([]);
  const [allTitles, setAllTitles] = useState([]);
  const [reversedTitles, setReversedTitles] = useState([]);
  const filtersGrid = useRef(null);

  const materialFilterGroup = filterGroups.find(filterGroup => filterGroup.name.trim() === "Countertop Material");
  const filterValuesAvailable = materialFilterGroup.values.filter(filterValue => {
    return currentParent.filtersReceived.includes(filterValue.id)
  })

  const columnWidth = selectionWindowView === 1 ? listItemHeight - 14 : (listItemHeight - 6)/2;
  const navigationViewType = selectionWindowView === 3 ? 2 : selectionWindowView; // 2

  useEffect(() => {
    const {firstTitle} = getFeaturesAndFirstTitle();
    setCurrentFilter(Object.assign({}, firstTitle));
    setDefaultTitle(Object.assign({}, firstTitle));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const {renderFeatures} = getFeaturesAndFirstTitle();
    setGridFeatures([...renderFeatures]);
    let newAllTitles = [defaultTitle, ...renderFeatures]
      .filter(renderFeature => renderFeature && (renderFeature.type === "filter_header"))
      .map(renderFeature => {
        const {columnIndex, titleIndex} = renderFeature;
        // const {scrollLeft} = filtersGrid.current.getOffsetForCell({columnIndex: 0, rowIndex})
        const skipTitles = titleIndex - 1;
        const titleShift = skipTitles > 0
          ? (skipTitles * 45) - (skipTitles * (columnWidth + 5)) + 30
          : 30
        const scrollLeft = columnIndex * (columnWidth + 5) + titleShift;
        return {...renderFeature, scrollLeft}
      })
    // console.log("newAllTitles", newAllTitles);
    setAllTitles([...newAllTitles]);
    setReversedTitles([...newAllTitles.reverse()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTitle, currentFeatures.length, listItemHeight, selectionWindowView, currentParent.partId])

  const getFeaturesAndFirstTitle = () => {
    let renderFeatures = [];
    let titleIndex = 0;
    let firstTitle = null;

    for (let k = 0; k < filterValuesAvailable.length; k++) {
      const filterValue = filterValuesAvailable[k];
      const countertopsFiltered = currentFeatures.filter(feature => {
        if (!feature) {
          return false
        }
        const countertopFilters = getFilterGroupValues(feature.part, materialFilterGroup);
        return countertopFilters && countertopFilters.includes(filterValue.id)
      });
      if (countertopsFiltered.length) {
        const title = {
          titleIndex,
          scrollLeft: 0,
          // scrollLeft: (Math.ceil(renderFeatures.length / columnCount) * (listItemHeight + 5)) + titleSkip,
          filterValue,
          type: "filter_header",
          columnIndex: Math.ceil(renderFeatures.length / navigationViewType) // next one
        }
        if (!firstTitle) {
          firstTitle = title
        } else {
          const spacersCount = navigationViewType - (renderFeatures.length % navigationViewType);
          if (spacersCount !== navigationViewType) {
            for (let i = 0; i < spacersCount; i++) {
              renderFeatures.push({type: "spacer"})
            }
          }
          const spacersTitleCount = navigationViewType - 1; // 1 is title
          renderFeatures.push(title)
          for (let i = 0; i < spacersTitleCount; i++) {
            renderFeatures.push({type: "spacer"})
          }
        }
        renderFeatures = [...renderFeatures, ...countertopsFiltered];
        titleIndex++;
      }
    }
    const columnsToAdd = Math.floor(scrollElement.clientWidth / columnWidth) - 1;
    for (let i = 0; i < columnsToAdd; i++) { // adding additional spacers
      const check = renderFeatures[renderFeatures.length - 1 - i];
      if (check && (check.type === "filter_header" || check.type === "spacer")) {
        for (let j = 0; j < (navigationViewType * columnsToAdd); j++) {
          renderFeatures.push({type: "empty-spacer"})
        }
        break;
      }
    }
    return {renderFeatures, firstTitle}
  }

  // console.log("gridFeatures render", gridFeatures);
  // console.log("allTitles render", allTitles);
  // console.log("reversedTitles render", reversedTitles);

  const onGridScroll = (props) => {
    const {scrollLeft} = props;
    // console.log("scrollLeft", scrollLeft);
    for (let i = 0; i < reversedTitles.length; i++) {
      const shiftTitle = reversedTitles[i];
      if (!scrollLeft) {
        const firstT = reversedTitles[reversedTitles.length - 1]
        if (shiftTitle.filterValue.id !== firstT.filterValue.id) {
          setCurrentFilter(Object.assign({}, firstT))
        }
        break;
      } else if (scrollLeft > shiftTitle.scrollLeft) {
        if (shiftTitle.filterValue.id !== currentFilter.filterValue.id) {
          setCurrentFilter(Object.assign({}, shiftTitle))
        }
        break;
      }
    }
    onScroll(props)
  };

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    let index = (navigationViewType * columnIndex) + rowIndex;
    if (!gridFeatures[index]) {
      return null
    } else if (gridFeatures[index].type === "filter_header") {
      return <SelectionGridFiltersTitle style={style}
                                        rowIndex={rowIndex}
                                        filterTitle={gridFeatures[index]}
                                        key={key}
                                        isHorizontal={true}
                                        allTitles={allTitles}
                                        filtersGrid={filtersGrid}/>
    } else if (gridFeatures[index].type === "spacer") {
      return <div className="empty-spacer" style={Object.assign({} , style, {width: 30})} key={key}/>
    } else if (gridFeatures[index].type === "empty-spacer") {
      return <div className="empty-spacer" style={style} key={key}/>
    }
    return (
      <div key={key} style={style}>
        <SelectionGridItem
          styles={{}}
          currentFeature={gridFeatures[index]}
          checkIfFeatureSelected={checkIfFeatureSelected}
          handleFeatureClick={handleFeatureClick}
          handleUserLoginClick={handleUserLoginClick}/>
      </div>
    )
  }

  const getColumnWidth = (props) => {
    const {index} = props;
    const firstRowFeatureIndex = navigationViewType * index;
    if (gridFeatures[firstRowFeatureIndex] && gridFeatures[firstRowFeatureIndex].type === "filter_header") {
      return 45
    }
    return columnWidth + 5
  }

  const columnsCount = Math.ceil(gridFeatures.length / navigationViewType); // for ex. 28/2 = 14 columns

  return (
    <Fragment>
      {currentFilter ? (
        <SelectionGridFiltersTitle filterTitle={currentFilter}
                                   allTitles={allTitles}
                                   isTopTitle={true}
                                   isHorizontal={true}
                                   filtersGrid={filtersGrid}/>
      ) : null}
      <AutoSizer>
        {() => {
          return (
            <Grid ref={filtersGrid}
                  rowCount={navigationViewType}
                  columnCount={columnsCount}
                  width={scrollElement.clientWidth ? scrollElement.clientWidth - 30 : 0}
                  height={(columnWidth * navigationViewType) - 1}
                  onScroll={onGridScroll}
                  columnWidth={getColumnWidth}
                  rowHeight={columnWidth}
                  overscanRowCount={5}
                  cellRenderer={cellRenderer}>
            </Grid>
          )
        }}
      </AutoSizer>
    </Fragment>
  )
}

SelectionMainVirtualizedFiltersGridMobile.propTypes = {
  currentFeatures: PropTypes.array,
  handleFeatureClick: PropTypes.func.isRequired,
  handleUserLoginClick: PropTypes.func.isRequired,
  checkIfFeatureSelected: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  currentParent: PropTypes.object.isRequired,
  listItemHeight: PropTypes.number,
  scrollElement: PropTypes.any, // div
  firstFilterTitle: PropTypes.shape(shiftFilterTitleInterface)
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  return {
    selectionWindowView,
    filterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainVirtualizedFiltersGridMobile)
